/** Drive API — Phase 2+. createApi('google-drive') → /api/google-drive */
import { createApi } from './_factory'
import type { DriveNs, ScreenNs } from '@shared/types'

const api = createApi('google-drive')

export const DriveApi = {
  listFiles: (data: DriveNs.ListFilesRequest) =>
    api.post<DriveNs.ListFilesRequest, DriveNs.ListFilesResponse>('list-files', data),

  importToRag: (data: DriveNs.ImportToRagRequest) =>
    api.post<DriveNs.ImportToRagRequest, DriveNs.IngestionResponse>('import-to-rag', data),

  attachToScreen: (data: DriveNs.AttachToScreenRequest) =>
    api.post<DriveNs.AttachToScreenRequest, ScreenNs.Screen[]>('attach-to-screen', data),

  export: (data: DriveNs.ExportRequest) =>
    api.post<DriveNs.ExportRequest, DriveNs.ExportResponse>('export', data),

  importContent: (data: DriveNs.ImportContentRequest) =>
    api.post<DriveNs.ImportContentRequest, DriveNs.ImportContentResponse>('import-content', data),
}
